import { styled } from '@mui/system';
import { Box, Paper } from '@mui/material';

export const ModalContainer = styled(Paper)(({ width = 450, maxHeight = '50vh', variant = 'default', theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: width,
  padding: theme.spacing(3),
  outline: 'none',
  maxHeight: maxHeight,
  overflowY: 'auto',
  borderRadius: theme.spacing(3),
  backgroundColor: variant === 'secondary' ? theme.palette.background.paper : theme.palette.background.dark,
  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25), 0 12px 24px rgba(0, 0, 0, 0.15)',
  border: `1px solid ${theme.palette.divider}`,
  '& .MuiTypography-h6': {
    fontSize: '17px',
    lineHeight: '22px',
    letterSpacing: '-0.408px',
    fontWeight: 600,
  },
}));

export const CloseButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: 1,
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

export const ModalContentLeft = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
}));
